import { ReachAPI } from './ReachAPI';
import { Log } from '../AuxillaryService/Log';

/**
 * @class placeexchange
 * @hideconstructor
 * @memberof ReachAPI
 */
ReachAPI.placeexchange = {};

/**
 * Gets Token for the place exchange widget
 * @param {ReachAPI.Security} security
 * @param {number} widgetId
 * @throws {ReachApiError}
 * @returns {Promise<ReachApiResponse>}
 * @memberof ReachAPI.placeexchange
 */
ReachAPI.placeexchange.getCredentials = function (security, widgetId) {
    var url = ReachAPI.server + '/signage/place_exchange/credentials/' + widgetId;
    var params = {};
    var jqPromise;

    params = security.merge(params);

    jqPromise = ReachAPI.get(url, 'json', params);

    jqPromise.done(function () {
        Log.Debug('Retrieved account data from the API', null, __fileline);
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve placexchange account data',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return ReachAPI.deferredToPromise(jqPromise);
};
